import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "privacy-modal",
    role: "dialog",
    "aria-labelledby": "privacy-title",
    "aria-modal": "true"
};
const _hoisted_2 = { class: "privacy-content" };
const _hoisted_3 = { class: "privacy-header" };
const _hoisted_4 = {
    id: "privacy-title",
    class: "privacy-title"
};
const _hoisted_5 = { class: "privacy-body" };
const _hoisted_6 = { class: "privacy-section" };
const _hoisted_7 = { class: "privacy-section" };
const _hoisted_8 = { class: "privacy-section" };
const _hoisted_9 = { class: "privacy-section" };
const _hoisted_10 = { class: "privacy-section" };
const _hoisted_11 = { class: "privacy-section" };
const _hoisted_12 = { class: "privacy-section" };
const _hoisted_13 = ["href"];
const _hoisted_14 = { class: "privacy-footer" };
const _hoisted_15 = { class: "privacy-date" };
import { computed } from 'vue';
import { useI18n } from '../../composables/useI18n';
import { config } from '@/config';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PrivacyPolicyModal',
    props: {
        visible: { type: Boolean },
        t: {}
    },
    emits: ["close"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { t } = useI18n();
        const contactEmail = config.emails.company;
        const lastUpdated = new Date().toLocaleDateString();
        const headerContactTitle = computed(() => {
            return t.value?.header?.contact || 'Contact';
        });
        const additionalInfoTitle = computed(() => {
            return t.value?.contact?.additionalInfo?.title || 'Business Inquiries';
        });
        const formattedContactContent = computed(() => {
            const template = t.value?.privacyPolicy?.contact?.content;
            if (!template) {
                return `For any questions regarding data processing, you can contact us through the "${headerContactTitle.value}" section in the website header via the email in the "${additionalInfoTitle.value}" tab: `;
            }
            return template
                .replace(/{{headerContact}}/g, headerContactTitle.value)
                .replace(/{{additionalTitle}}/g, additionalInfoTitle.value);
        });
        const onClose = () => {
            emit('close');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
                default: _withCtx(() => [
                    (__props.visible)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("div", {
                                class: "privacy-overlay",
                                onClick: onClose
                            }),
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(t)?.privacyPolicy?.title || 'Privacy Policy'), 1),
                                    _createElementVNode("button", {
                                        class: "privacy-close",
                                        onClick: onClose,
                                        "aria-label": "Close privacy policy"
                                    }, [...(_cache[0] || (_cache[0] = [
                                            _createElementVNode("svg", {
                                                viewBox: "0 0 24 24",
                                                fill: "none"
                                            }, [
                                                _createElementVNode("path", {
                                                    d: "M18 6L6 18M6 6L18 18",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    "stroke-linecap": "round"
                                                })
                                            ], -1)
                                        ]))])
                                ]),
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("h3", null, _toDisplayString(_unref(t)?.privacyPolicy?.dataCollection?.title), 1),
                                        _createElementVNode("p", null, _toDisplayString(_unref(t)?.privacyPolicy?.dataCollection?.content), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("h3", null, _toDisplayString(_unref(t)?.privacyPolicy?.cookies?.title), 1),
                                        _createElementVNode("p", null, _toDisplayString(_unref(t)?.privacyPolicy?.cookies?.content), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("h3", null, _toDisplayString(_unref(t)?.privacyPolicy?.thirdParty?.title), 1),
                                        _createElementVNode("p", null, _toDisplayString(_unref(t)?.privacyPolicy?.thirdParty?.content), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("h3", null, _toDisplayString(_unref(t)?.privacyPolicy?.yourRights?.title), 1),
                                        _createElementVNode("p", null, _toDisplayString(_unref(t)?.privacyPolicy?.yourRights?.content), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("h3", null, _toDisplayString(_unref(t)?.privacyPolicy?.dataStorage?.title), 1),
                                        _createElementVNode("p", null, _toDisplayString(_unref(t)?.privacyPolicy?.dataStorage?.content), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("h3", null, _toDisplayString(_unref(t)?.privacyPolicy?.compliance?.title), 1),
                                        _createElementVNode("p", null, _toDisplayString(_unref(t)?.privacyPolicy?.compliance?.content), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("h3", null, _toDisplayString(_unref(t)?.privacyPolicy?.contact?.title), 1),
                                        _createElementVNode("p", null, [
                                            _createTextVNode(_toDisplayString(formattedContactContent.value) + " ", 1),
                                            _createElementVNode("a", {
                                                href: `mailto:${_unref(contactEmail)}`,
                                                class: "privacy-email-inline"
                                            }, _toDisplayString(_unref(contactEmail)), 9, _hoisted_13)
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(t)?.privacyPolicy?.lastUpdated || 'Effective as of'), 1)
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }));
        };
    }
});
